/**
 * Navigate with a full page load rather than a client-side route change.
 *
 * For the moments the whole app has to start again under a different token —
 * entering and leaving a simulation — because the dashboard reads the token
 * once on mount, in more places than a route change would reach.
 *
 * Its own module so tests can replace it: jsdom's `window.location` cannot be
 * stubbed.
 */
export const loadPage = (path) => {
  window.location.assign(path);
};
